import styled from 'styled-components';
import colors from '../../../../styles/settings/colors';
import fontSize from '../../../../styles/settings/fontSize';
import { Dialog } from '@material-ui/core';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: '#F2F1F1';
  overflow-x: hidden;
  width: 100%;
`;

export const DatePicker = styled.div`
  width: auto !important;
`;

export const AnchorLogo = styled.div`
  border: 2px solid #424242;
  margin: 0 0 8px;
  background-color: white;
  text-align: center;
  img {
    cursor: pointer;
    height: 100px;
    width: 100%;
    max-width: 200px;
    max-height: 80px;
  }
`;

export const MetasBox = styled.div`
  border-radius: 4px;
  /* box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%),
    0px 1px 5px 0px rgb(0 0 0 / 12%); */
`;

export const Content = styled.div`
  display: flex;
  flex-direction: row;
  margin: 0 16px;
  position: relative;
  overflow-x: hidden;
  top: 190px;
  width: 100%;
`;

// Operation Table Style
export const OperationHeaderButtons = styled.div`
  display: flex;
  flex-flow: row wrap;
  margin: 8px 0;

  button {
    margin: 0 4px;
  }
`;

export const OperationTableContainer = styled.div`
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%),
    0px 1px 5px 0px rgb(0 0 0 / 12%);
  display: flex;
  flex-flow: row nowrap;
  min-height: 280px;

  .operation {
    width: ${(props) => (props.hasCalcBox ? '85%' : '100%')};
  }

  .title-header {
    background-color: ${colors.sanMarino};
    border-radius: 4px 4px 0 0;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;

    svg {
      color: white;
      width: 15px;
    }
  }

  .operation-title {
    align-items: center;
    background-color: ${colors.sanMarino};
    border-radius: 0 4px 0 0;
    color: #fff;
    display: flex;
    flex-flow: row wrap;
    font-size: ${fontSize.headerTable};
    height: 17px;
    margin: 0 auto;
    padding: 4px;
  }

  .operation-content {
    display: flex;
    flex-flow: row nowrap;
    padding: 4px;

    .left-content {
      width: 65%;
    }

    .right-content {
      display: flex;
      flex-flow: row wrap;
      justify-content: center;
      width: 35%;

      button {
        height: 45px;
        margin: 8px 8px 4px 8px;
        width: 100%;
      }
    }
  }

  .operation-calc {
    border-left: 2px solid #b0b0b0;
    width: 18%;
    > div {
      align-items: center;
      bottom: 20px;
      display: flex;
      flex-flow: column wrap;
      justify-content: center;
      height: 100%;
      position: relative;
      padding: 0 8px;
    }
    .calc-input {
      border: 1px solid;
      border-radius: 6px;
      margin: 0;

      .MuiInput-formControl {
        font-size: ${fontSize.tableRowText};
        p {
          font-size: ${fontSize.tableRowText};
        }
      }
    }

    button {
      margin: 8px 0;
      width: 95%;
    }
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-flow: row nowrap;
  margin: 0 0 8px;
  span {
    font-size: ${fontSize.tableRowText};
  }
  .content-label {
    margin-right: 8px;
    width: 27%;
  }

  .content-value {
    width: 70%;
  }
`;

export const ArrowDateOption = styled.span`
  margin: ${(props) => (props.hasArrow ? '0 8px' : 0)};
`;

export const ValuesContainer = styled.div`
  display: flex;
  flex-flow: ${(props) => (props.column ? 'column wrap' : 'row wrap')};
  margin: 0 0 8px;
  justify-content: space-between;
  width: ${(props) => props.width || '100%'};

  .right-label {
    width: ${(props) => (props.fullWidth ? '100%' : '45%')};
  }

  .right-value {
    margin-right: 8px;
    text-align: ${(props) => (props.fullWidth ? 'left' : 'right')};
    width: ${(props) => (props.fullWidth ? '100%' : '45%')};
  }

  span {
    font-size: ${fontSize.tableRowText};
  }

  .MuiInputBase-input {
    padding: 6px 6px 7px;
  }
`;

export const TaxDialog = styled(Dialog)`
  .MuiDialogContent-root {
    padding: 8px 8px 0 !important;
  }

  .tax-dialog-header {
    background: ${colors.sanMarino};
    color: #fff;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    text-align: center;
    .title-header {
      width: 100%;
    }
    .footer-title {
      text-align: right;
      width: 60%;
    }
    .real-formatted {
      align-self: flex-end;
      justify-content: space-between;
      padding: 0 8px;
      width: 29%;
    }
  }
`;

export const JurosContainer = styled.div`
  border: 1px solid #424242;
  margin: 0 auto;

  > div {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    padding: 0 8px;
    &:nth-child(odd) {
      background-color: ${colors.oddColor};
    }

    .juros-bank {
      width: 50%;
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;

      .w-50 {
        width: 50%;
      }
    }

    span {
      font-size: ${fontSize.text};
    }
    .juros-title {
      width: 30%;
    }
    .juros-tax {
      width: 20%;
    }
    .juros-value {
      width: 30%;
    }
  }

  .total {
    background-color: ${colors.tacao}!important;
  }
`;

// Notes

export const TableContent = styled.div`
  margin: 16px 0;
  &.without-scroll {
    > div {
      max-height: 100%;
      overflow-y: initial;
    }
  }

  .check-icon {
    width: 15px;
    height: 15px;
    position: relative;
    left: 2px;
    top: 2px;
  }

  .width-column-loja {
    min-width: 150px;
  }

  .react-bootstrap-table {
    bottom: 6px;
    position: relative;
    overflow: auto;
    .table {
      min-width: 100%;
      width: auto;
    }
    .react-bootstrap-table-sort-order,
    .order {
      display: none;
    }

    .filter.text-filter {
      margin-left: 8px;
    }
    & thead th {
      background: ${colors.sanMarino};
      color: ${colors.white};
      position: sticky;
      top: 0;
      z-index: 1;
    }

    .has-action-btn {
      .action-btn {
        margin: 0;
        padding: 0;
        position: relative;
        bottom: 2px;
        left: 2px;
      }
    }
  }

  .table {
    font-size: ${fontSize.tableRowText}!important;
    width: auto;
    thead {
      tr {
        text-align: left;
      }
    }
    tbody {
      tr {
        td {
          white-space: nowrap;
        }
        td.long-td:first-child {
          min-width: 350px;
        }
      }
    }
  }
  .table-striped tbody tr:nth-of-type(odd) {
    background-color: ${colors.oddColor};
  }

  .table-striped tbody tr:nth-of-type(even) {
    background-color: ${colors.evenColor};
  }

  > div {
    max-height: ${(props) => (props.threeLines ? '95px' : 'calc(100vh - 300px)')};
    overflow-y: scroll;
  }

  thead > tr {
    white-space: nowrap;
  }

  .MuiInputBase-root {
    font-size: ${fontSize.tableRowText}!important;
  }

  .MuiIcon-root {
    height: ${fontSize.tableRowText};
    font-size: ${fontSize.tableRowText};
    width: ${fontSize.tableRowText};
  }

  .MuiTableRow-root {
    &:nth-child(odd) {
      background-color: ${colors.oddColor};
    }
  }
  .MuiTableCell-root {
    padding: 0 2px !important;
  }

  .action-btn {
    min-width: 20px !important;
  }
  .MuiTableCell-head:last-child {
    text-align: left !important;
  }
`;

export const TableTitleHeader = styled.div`
  align-items: center;
  background-color: ${colors.sanMarino};
  border-radius: 4px 4px 0 0;
  color: #fff;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  overflow-y: hidden !important;
  padding: 0;

  .operation-title {
    font-size: ${fontSize.headerTable};
    font-weight: bold;
    margin: 0 auto;
    padding: 2px 4px;
  }

  .operation-actions {
    display: flex;
  }

  svg {
    color: white;
    margin-right: 8px;
    width: 15px;
  }
`;

export const MetasContainer = styled.div`
  p {
    margin: 0;
    padding: 0;
  }
  .metas-header {
    background: ${colors.sanMarino};
    color: #fff;
    display: flex;
    flex-flow: row nowrap;
    font-size: ${fontSize.tableRowText};
    font-weight: bold;
    justify-content: space-between;
    padding: 0 8px;
    p:first-child {
      text-align: left;
      width: 32%;
    }
    p {
      border-right: 1px solid white;
      width: 25%;
    }
    p:last-child {
      border-right: 0 solid white;
      text-align: right;
      width: 12%;
    }
  }
  .metas-body {
    display: flex;
    flex-flow: column wrap;
    .metas-body-row {
      align-items: center;
      display: flex;
      flex-flow: row nowrap;
      height: 24px;
      justify-content: space-between;
      font-size: ${fontSize.tableRowText};
      padding: 0 8px;
      &:nth-child(odd) {
        background-color: ${colors.oddColor};
      }
      &:nth-child(even) {
        background-color: ${colors.evenColor};
      }

      p:first-child {
        text-align: left;
        width: 32%;
      }
      p {
        border-right: 1px solid white;
        text-align: right;
        width: 25%;
      }
      p:last-child {
        border-right: 0px solid white;
        text-align: right;
        width: 12%;
      }
    }
  }
`;

// Anotations

export const AnotationContainer = styled.div`
  /* box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%),
    0px 1px 5px 0px rgb(0 0 0 / 12%); */

  .operation-title {
    align-items: center;
    display: flex;
    font-size: ${fontSize.headerTable};
    margin: 0 auto;
  }

  button {
    margin-right: 8px;
  }
`;

export const AnotationBody = styled.div`
  max-height: 150px;
  overflow-y: scroll;

  .anotation-body-message {
    background: #fff;
    border-bottom: 1px solid #c4c4c4;
    min-height: 50px;
    padding: 0 1px;

    &:nth-of-type(odd) {
      background-color: ${colors.oddColor};
    }
    &:nth-of-type(even) {
      background-color: ${colors.evenColor};
    }
    .anotation-message-header {
      display: flex;
      font-size: ${fontSize.tableRowText};
      width: 100%;

      /* span {
        border-right: 1px solid #fff;
      } */
      span.user-field {
        width: 75%;
      }

      span:first-child {
        width: 12%;
      }
      span:last-child {
        border-right: 0 solid #fff;
        margin: 0 0 0 auto;
        width: 13%;
      }
    }
    p {
      font-size: ${fontSize.tableRowText};
      margin: 4px 0;
    }
  }
`;

export const NewAnotation = styled.div`
  border-bottom: 1px solid #424242;
  margin: 8px 0;
  .new-body {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    padding: 8px;

    .new-body-left {
      align-items: flex-end;
      display: flex;
      flex-flow: column wrap;
      width: 100%;
      .input-message {
        border-radius: 8px;
        font-size: ${fontSize.tableRowText};
        padding: 8px;
        position: relative;
        top: 3px;
        width: 100%;
      }

      button {
        margin: 0;
        margin-top: auto;
      }
    }

    .schedule-input {
      display: flex;
      flex-flow: column;
      font-size: ${fontSize.tableRowText};
      margin-bottom: 24px;

      .react-datepicker__input-container {
        input {
          width: 77px;
        }
      }

      .MuiInputBase-root {
        background: #fff;
        border: 1px solid #424242;
        border-radius: 4px;
        font-size: 11px;
        height: 30px;
        padding: 4px;
        width: 85px;
      }
    }

    .new-body-schedule {
      align-items: flex-end;
      flex-flow: column wrap;
      display: flex;
      padding: 0 0 0 16px;
      width: 17%;

      button {
        font-size: ${fontSize.tableRowText};
        margin: 0;
        width: 85px;
      }
    }
  }
`;

// Messages

export const MessageContainer = styled.div`
  box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%),
    0px 1px 5px 0px rgb(0 0 0 / 12%);
  margin: 16px 0 8px;
`;

export const MessageBody = styled.div`
  background-color: ${colors.white};
  font-size: ${fontSize.tableRowText};
  padding: 4px 0;

  .bold {
    font-weight: bold;
  }
  .message-ip {
    margin: 16px;
  }

  p {
    font-size: ${fontSize.tableRowText};
    margin: 0;
    padding: 0 8px;
  }

  .message-header {
    color: ${colors.tundora};
  }
  .message-text {
    font-size: ${fontSize.tableRowText};
    margin: 8px 0;
  }
`;

export const FakeButton = styled.div`
  height: 45px;
  margin: 8px 8px 4px 8px;
  min-width: 178px;
  width: 100%;
`;
